import AvatarWithText from './AvatarWithText';

export default AvatarWithText;
